export default __webpack_public_path__ + "static/media/noresult.79019a44.svg";